<template>
  <div class="expert">
    <img class="loading" v-if="loading == true" src="../../../../static/common/loading.png" alt="">
    <div class="expertBoxs" v-for="item in expertData" :key="item.ID">
      <div class="title">{{ item.date }}</div>

      <div class="comments-list">
        <div class="comments-list-item" v-for="(items, indexs) in item.List" :key="indexs">
          <img class="comments-list-item-cover" :src="items.coverPhotoLink" alt="">
          <div class="comments-list-item-right">
            <div class="comments-list-item-right-title" @click="clickExpert(items.id)">
              {{ items.title }}
            </div>
            <div class="comments-list-item-right-content">
              <div class="comments-list-item-right-content-text">
                {{ items.synopsis }}
              </div>
              <div class="comments-list-item-right-content-time">
                {{ items.postTime.substring(0, 16) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button @click="moreExpert">
      <span>加载更多</span>
      <img src="../../../../static/market/more.png" alt="">
    </button>
  </div>
</template>

<script>

import { postCmsSystemRelay } from '@/apis/transfer'

export default {
  name: 'expert',
  data() {
    return {
      expertData: [],
      // 接口参数
      attr: {
        type: "COMMANT",
        groupCode: "",
        pageIndex: 1,
        pageRow: 5,
      },
      loading: true,
    }
  },
  created() {
    // 初始化数据
    this.init(this.attr, 0);

  },
  methods: {
    // 数据接口
    init(attr, key) {
      postCmsSystemRelay('hotNewsApi', attr).then(res => {
        res.lst = this.changeDate(res.lst)

        if (key == 1) {
          this.expertData = [...this.expertData, ...res.lst];
          this.expertData = this.changeDates(this.expertData)

        } else {
          this.expertData = res.lst;
          this.loading = false;
        }
      }).catch(err => {
        console.log(err);
      })
    },
    // 第一次处理
    changeDate(arr) {
      let dataArr = [];
      arr.map(mapItem => {
  
        if (dataArr.length == 0) {
          dataArr.push({ date: (mapItem.postTime).slice(0, 7), List: [mapItem] })
        } else {
          let res = dataArr.some(item => {//判断相同日期，有就添加到当前项
            if (item.date == mapItem.postTime.slice(0, 7)) {
              item.List.push(mapItem)
              return true
            }
          })
          if (!res) {//如果没找相同日期添加一个新对象
            dataArr.push({ date: mapItem.postTime.slice(0, 7), List: [mapItem] })
          }
        }

      })
      return dataArr

    },
    // 第二次处理
    changeDates(tempArr) {
      for (let i = 0; i < tempArr.length; i++) {
        for (let j = i + 1; j < tempArr.length; j++) {
          if (tempArr[i].date == tempArr[j].date) {
            tempArr[i].List = [...tempArr[i].List, ...tempArr[j].List]
            tempArr.splice(j, 1);
            j--;
          };
        };
      }
      return tempArr
    },
    // 获取更多评论 
    moreExpert() {
      if (this.attr.pageRow == 5) {
        this.attr.pageIndex = 1;
        this.attr.pageRow = 10;
        this.init(this.attr, 0);
      } else {
        this.attr.pageIndex++;
        this.init(this.attr, 1);
      }
    },
    // 跳转到评论详情页
    clickExpert(attr) {
      let routeData = this.$router.resolve({
        name: "expertDetails",
        query: {
          id: attr
        }
      });
      window.open(routeData.href, '_blank');
    }
  }
}
</script>

<style lang="less" scoped>
.expert {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .loading {
    margin: 0 auto 30px;
    width: 50px;
  }

  .expertBoxs {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    padding: 36px;
    box-sizing: border-box;
    width: 100%;
    height: auto;
    margin-bottom: 36px;
    display: flex;
    flex-direction: column;

    .title {
      color: #FA2314;
      font-size: 24px;
      line-height: 32px;
      font-weight: 700;
      margin-bottom: 34px;
    }
  }

  .boxs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .expertBox {
    width: 45%;
    height: 88px;
    box-sizing: border-box;
    padding: 0;
    display: flex;
    background-color: #f8f8f8;
    background-color: #fff;
    margin-bottom: 40px;
    align-items: center;
    flex-wrap: wrap;

    .titlePic {
      width: 200px;
      height: auto;
    }

    ul {
      width: 61%;
      height: 90%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      box-sizing: border-box;
      padding-top: 10px;
      padding-left: 20px;

      li {
        width: 100%;

        p {
          display: flex;
          justify-content: center;
          align-items: center;

          // margin-left: 20px;
          img {
            margin-right: 8px;
          }
        }
      }

      li:nth-child(1) {

        cursor: pointer;
        color: #0F0F11;
        font-size: 16px;
        line-height: 22px;
        font-weight: 700;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }

      li:nth-child(2) {
        display: flex;
        align-items: center;
        line-height: 22px;
        font-size: 14px;
        color: #93939F;

        .box-content {
          display: flex;
          align-items: end;
        }

        p {
          width: 59%;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }

      }

    }
  }

  button {
    width: 195px;
    height: 60px;
    border-radius: 5px;
    // background-color: #db3d4c;
    background-color: #FAFAFA;
    border: none;
    margin: 32px auto 110px;
    cursor: pointer;

    span {
      color: #ffffff;
      margin-right: 5px;
      color: #FA2314;
      text-decoration: underline;
    }

    img {
      width: 10px;
      height: auto;
    }
  }

  .comments-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    &-item {
      width: 48%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 30px 0;
      border-bottom: 1px solid #f1f1f1;

      &-cover {
        width: 200px;
        height: 88px;
        flex-shrink: 0;
        margin-right: 20px;
        object-fit: cover;
      }

      &-right {
        // flex: 1;
        width: 354px;

        &-title {
          font-weight: 700;
          color: #000;
          cursor: pointer;
          margin-bottom: 10px;
          white-space: nowrap;
          /* 禁止文本换行 */
          overflow: hidden;
          /* 超出部分隐藏 */
          text-overflow: ellipsis;
          /* 超出部分显示省略号 */
        }

        &-content {
          display: flex;
          justify-content: space-between;
          align-items: end;
          font-size: 14px;
          color: #93939F;

          &-text {
            height: 44px;
            width: 58%;
            width: 212px;
            line-height: 22px;
            display: -webkit-box;
            /* 必须使用这个属性来支持多行省略号 */
            -webkit-box-orient: vertical;
            /* 必须设置为纵向排列 */
            -webkit-line-clamp: 2;
            /* 限制显示最多两行 */
            overflow: hidden;
            /* 超出部分隐藏 */
            text-overflow: ellipsis;
            /* 超出部分显示省略号 */
          }

          &-time {
            color: #93939F;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .expert {
    .loading {
      margin: 0 auto 30px;
      width: 30px;
    }

    .expertBoxs {
      .title {
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 0;
      }

      .boxs {
        display: flex;
        flex-direction: column;
      }
    }

    .expertBox {
      // flex-direction: column;
      width: 100%;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: center;
      height: auto;
      margin-bottom: 10px;
      padding: 15px 0;

      .titlePic {
        width: 120px;
        height: 74px;
        border-radius: 5px;
      }

      ul {
        width: 56%;
        padding-left: 0;
        padding-top: 0px;
        box-sizing: border-box;

        li:nth-child(1) {
          font-size: 14px;
          font-weight: 600;
        }

        li:nth-child(2) {
          font-size: 12px;
          margin: 6px auto 10px;

          p {
            width: 100%;
            -webkit-line-clamp: 1;
          }

          .box-content {
            flex-direction: column;
          }
        }

        li:nth-child(3) {
          p {
            margin-left: 10px;

            span {
              font-size: 12px;
            }

            img {
              width: 18px;
              height: auto;
              margin-right: 3px;
            }
          }
        }
      }
    }

    button {
      width: 125px;
      height: 40px;
      border-radius: 5px;
      background-color: #FAFAFA;
      border: none;
      cursor: pointer;
      color: #ffffff;
      margin: 20px 0;
      font-size: 14px;
    }

    .comments-list {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;

      &-item {
        width: 100%;

        &-cover {
          width: 120px;
          height: 74px;
          object-fit: cover;
        }

        &-right {
          flex: 1;
          width: 50%;

          &-title {
            font-size: 16px;
            width: 100%;
          }

          &-content {
            font-size: 12px;
            display: flex;
            flex-direction: column;
            align-items: end;

            &-text {
              height: 17px;
              width: 100%;
              display: -webkit-box;
              /* 必须使用这个属性来支持多行省略号 */
              -webkit-box-orient: vertical;
              /* 必须设置为纵向排列 */
              -webkit-line-clamp: 1;
              /* 限制显示最多两行 */
              overflow: hidden;
              /* 超出部分隐藏 */
              text-overflow: ellipsis;
              /* 超出部分显示省略号 */
            }

            &-time {
              text-align: right;
              margin-top: 12px;
            }
          }
        }
      }
    }
  }
}

// -------------------------小屏幕适配-------------------
@media screen and (min-width: 1264px) and (max-width: 1724px) {
  .expert {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;





    .comments-list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      &-item {


        &-right {
          // flex: 1;
          width: 236px;

          &-title {
            font-weight: 700;
            color: #000;
            cursor: pointer;
            margin-bottom: 10px;
            white-space: nowrap;
            /* 禁止文本换行 */
            overflow: hidden;
            /* 超出部分隐藏 */
            text-overflow: ellipsis;
            /* 超出部分显示省略号 */
          }

          &-content {
            display: flex;
            justify-content: space-between;
            align-items: end;
            font-size: 14px;
            color: #93939F;

            &-text {
              height: 44px;
              width: 58%;
              width: 112px;
              line-height: 22px;
              display: -webkit-box;
              /* 必须使用这个属性来支持多行省略号 */
              -webkit-box-orient: vertical;
              /* 必须设置为纵向排列 */
              -webkit-line-clamp: 2;
              /* 限制显示最多两行 */
              overflow: hidden;
              /* 超出部分隐藏 */
              text-overflow: ellipsis;
              /* 超出部分显示省略号 */
            }

            &-time {
              color: #93939F;
              font-size: 12px;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
}
</style>
